import { render, staticRenderFns } from "./VhomeVlog.vue?vue&type=template&id=4657b460&scoped=true&"
import script from "./VhomeVlog.vue?vue&type=script&lang=js&"
export * from "./VhomeVlog.vue?vue&type=script&lang=js&"
import style0 from "./VhomeVlog.vue?vue&type=style&index=0&id=4657b460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4657b460",
  null
  
)

export default component.exports